export const ORGANIZER_UPDATED = "wedding-organizer-updated";

// POST is also used for reads in this API, so only recognize known write routes.
export function notifyOrganizerWrite(url, method, response) {
  if (!response?.ok || !["POST", "PUT", "PATCH", "DELETE"].includes((method || "GET").toUpperCase())) return;
  try {
    const base = new URL(process.env.REACT_APP_API_BASE, window.location.origin);
    const target = new URL(url, window.location.origin);
    if (target.origin !== base.origin) return;
    const prefix = base.pathname.replace(/\/$/, "");
    if (prefix && !target.pathname.startsWith(`${prefix}/`)) return;
    const path = target.pathname.slice(prefix.length);
    if (/^\/(guests|guest-group|seats|tables|todos)(\/|$)/.test(path) ||
        /^\/(create|remove)-seats-group$/.test(path) ||
        /^\/weddings\/[^/]+\/finance\//.test(path)) {
      window.dispatchEvent(new Event(ORGANIZER_UPDATED));
    }
  } catch (_) {
    // Notifications must never interfere with the original request.
  }
}
